/*
 * @Author: yidan.chen
 * @Date: 2025-02-9 11:10:46
 * @Last Modified by: yidan.chen
 * @Last Modified time: 2025-04-24 16:28:35
 */
import { lazy, Suspense } from 'react'

const iconMap = {
  ManageAccounts: lazy(() => import('@mui/icons-material/ManageAccounts')),
  ReceiptLong: lazy(() =>
    import('./CustomIcon').then(module => ({ default: module.BillIcon }))
  ),
  Payments: lazy(() => import('@mui/icons-material/Payments')),
  Cash: lazy(() =>
    import('./CustomIcon').then(module => ({ default: module.CashIcon }))
  ),
  Apps: lazy(() => import('@mui/icons-material/Apps')),
  Flaky: lazy(() => import('@mui/icons-material/Flaky')),
  Download: lazy(() => import('@mui/icons-material/DownloadForOfflineRounded')),
  Group: lazy(() => import('@mui/icons-material/Groups')),
  ContactMail: lazy(() => import('@mui/icons-material/ContactMail')),
  Analytics: lazy(() => import('@mui/icons-material/Insights')),
  AdminPanelSettings: lazy(
    () => import('@mui/icons-material/AdminPanelSettings')
  ),
  LocalShipping: lazy(() => import('@mui/icons-material/LocalShipping'))
}

const DynamicIcon = ({
  iconName,
  ...props
}: {
  iconName: keyof typeof iconMap
  sx?: { height?: string | number; width?: string | number }
  [key: string]: any
}) => {
  const IconComponent = iconMap[iconName] || (() => <></>)
  return (
    <Suspense
      fallback={
        <div style={{ height: props.sx?.height, width: props.sx?.width }} />
      }>
      <IconComponent {...props} />
    </Suspense>
  )
}

export default DynamicIcon
